// extracted by mini-css-extract-plugin
export default {"main":"PublicDataPage_main__waKpc"};